import { createFileRoute } from "@tanstack/react-router";
import { ThemePreviewExamples } from "@/utils/design-system/examples-exports";

export const Route = createFileRoute("/demo/design-system/theming/examples")({
  component: ThemePreviewExamples,
});
